// Configuratie voor cookie toestemming
// Sla dit bestand op als 'cookie-config.js' in de assets map van je thema

(function() {
  // Google Analytics of Google Tag Manager ID
  window.GOOGLE_ANALYTICS_ID = "UA-XXXXXXXX-X"; // Vervang met je eigen ID
  
  // Facebook Pixel ID
  window.FACEBOOK_PIXEL_ID = "XXXXXXXXXX"; // Vervang met je eigen ID
  
  // Cookie toestemming configuratie
  window.COOKIE_CONSENT_CONFIG = {
    expireDays: 180,             // Hoe lang de keuze van de gebruiker wordt onthouden (in dagen)
    cookieName: 'shopify_cookie_toestemming',  // Naam van de cookie die toestemming opslaat
    showOnlyInEU: true,          // Op 'false' zetten om voor alle bezoekers te tonen
    
    // Tekst aanpassingen
    texts: {
      headerTitle: "Cookie Instellingen",
      mainText: "Wij gebruiken cookies om je winkelervaring te verbeteren. Sommige zijn noodzakelijk, andere helpen ons de website te verbeteren.",
      essentialCookiesTitle: "Noodzakelijke Cookies",
      essentialCookiesDesc: "Deze cookies zijn nodig om de website goed te laten werken.",
      analyticsCookiesTitle: "Analyse Cookies",
      analyticsCookiesDesc: "Deze cookies helpen ons te begrijpen hoe bezoekers onze website gebruiken.",
      marketingCookiesTitle: "Marketing Cookies",
      marketingCookiesDesc: "Deze cookies helpen ons relevantere advertenties te tonen.",
      acceptAllBtn: "Alles Accepteren",
      rejectAllBtn: "Alleen Noodzakelijke",
      savePreferencesBtn: "Voorkeuren Opslaan",
      privacyPolicyLink: "/pages/privacy-policy",
      cookiePolicyLink: "/pages/cookie-policy",
      privacyPolicyText: "Privacybeleid",
      cookiePolicyText: "Cookiebeleid"
    }
  };
})();